import React, { createContext, useContext } from 'react';

export const TTGAssessmentContext = createContext(undefined);

export const TTGAssessmentProvider = ({ children }) => {
    const [setupAssessment, setSetupAssessment] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const [assessmentDetails, setAssessmentDetails] = React.useState(null);
    const [newAssessmentId, setNewAssessmentId] = React.useState(null);
    const [reportData, setReportData] = React.useState(null);
    const [selectedFilter, setSelectedFilter] = React.useState(0);

    return (
        <TTGAssessmentContext.Provider
            value={{
                setupAssessment,
                setSetupAssessment,
                loading,
                setLoading,
                assessmentDetails,
                setAssessmentDetails,
                newAssessmentId,
                setNewAssessmentId,
                reportData,
                setReportData,
                selectedFilter,
                setSelectedFilter,
            }}
        >
            {children}
        </TTGAssessmentContext.Provider>
    );
};

export const useTTGAssessments = () => useContext(TTGAssessmentContext);

export const TTGAssessmentContextLayout = ({ children }) => <TTGAssessmentProvider>{children}</TTGAssessmentProvider>;
